




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { CouponResourceType } from '@/modules/coupon/models/coupon-resource.model'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminCouponStatus from '@/modules/coupon/components/admin/AdminCouponStatus.vue'

@Component({
  components: {
    AdminCouponStatus,
    BaseButton,
    DateTooltipped,
    TextEllipsis,
    TabularHeader
  }
})
export default class AdminCouponTabularHeader extends Vue {
  @Prop({ required: true }) couponResource: CouponResourceType

  private get couponResourceData() {
    return this.couponResource.data
  }

  private get tabularColumns() {
    return [
      {
        name: 'title',
        title: 'عنوان',
        value: this.couponResourceData.title
      },
      {
        name: 'code',
        title: 'کد تخفیف',
        value: this.couponResourceData.code
      },
      {
        name: 'amount',
        title: 'مقدار تخفیف',
        value: this.couponResourceData.amount.toLocaleString()
      },
      {
        name: 'type',
        title: 'نوع کمپین',
        value: this.couponResource.types[this.couponResourceData.type]
      },
      {
        name: 'status',
        title: 'وضعیت',
        value: {
          status: this.couponResourceData.status,
          statuses: this.couponResource.statuses
        }
      },
      {
        name: 'usedCount',
        title: 'استفاده شده',
        value: this.couponResourceData.used_count || 0
      },
      {
        name: 'createdAt',
        title: 'تاریخ ایجاد',
        value: this.couponResourceData.created_at
      }
    ]
  }
}
